export const ROLE = {
  ADMIN: 0,
  USER: 1
};
